import React from "react";
import { CalciteButton } from "@esri/calcite-components-react";

export type LocType = "Center" | "Home" | "School";

export type CostType =
  | "Free"
  | "Free for qualifying families"
  | "Cost varies, contact provider";

export type CareType =
  | "2-K Expanded Day Full Year"
  | "2-K School Day"  
  | "3-K City Transitional"
  | "3-K Extended Day"
  | "3-K School Day" 
  | "3-K School Day+"
  | "Early Head Start"
  | "Head Start"
  | "NYC Public Schools Infant Programs"
  | "NYC Public Schools Toddler Programs"
  | "Pre-K City Transitional"
  | "Pre-K Extended Day"
  | "Pre-K School Day" 
  | "Pre-K School Day+"
  | "Private Care"
  | "Toddler City Transitional";


const settingStyles: Record<LocType, { bg: string; text: string }> = {
  School: { bg: "#BBB2E7", text: "#262525" },
  Home: { bg: "#71C4A2", text: "#262525" },
  Center: { bg: "#FFBE67", text: "#262525" },
};

const costStyles: Record<CostType, { bg: string; text: string; label: string }> = {
  Free: { bg: "#7FBFFE", text: "#262525", label: "Free" },
  "Free for qualifying families": {
    bg: "#D6E6F5",
    text: "#262525",
    label: "Free for qualifying families",
  },
  "Cost varies, contact provider": { bg: "#D9D9D9", text: "#262525", label: "Cost varies, contact provider" },
};


// All care types use the same style
const genericCareTypeStyle = {
  bg: "#F0EFF8",
  border: "#101C76",
  text: "#262525"
};

export default function LocationBadges({
  locType,
  costType,
  careType,
}: {
  locType?: LocType;
  costType?: CostType;
  careType?: CareType;
}) {
  const setting = locType ? settingStyles[locType] : undefined;
  const cost = costType ? costStyles[costType] : undefined;
  const careTypeStyle = careType ? genericCareTypeStyle : undefined;
  
  return (
    <>

      {/* caretype_name badge first */}
      {careType && careTypeStyle && (
        <CalciteButton
          class="lib-secondary-button caretype-btn caretype-btn-outline"
          alignment="center"
          appearance="outline"
          kind="brand"
          scale="s"
          type="button"
          width="auto"
          style={{
            "--calcite-button-background-color": careTypeStyle.bg,
            "--calcite-button-border-color": careTypeStyle.border,
            "--calcite-button-text-color": careTypeStyle.text,
            "--calcite-button-corner-radius": "4px",
            padding: "2px 6px 6px 0px",
            margin: "0",
            pointerEvents: "none",
            cursor: "not-allowed",
          }}
        >
          {careType}
        </CalciteButton>
      )}

      {/* COST badge */}
      {cost && (
        <CalciteButton
          class="lib-secondary-button cost-btn"
          appearance="solid"
          scale="s"
          style={{
            "--calcite-button-background-color": cost.bg,
            "--calcite-button-text-color": cost.text,
            "--calcite-button-corner-radius": "4px",
            padding: "2px 6px 6px 0px",
            pointerEvents: "none",
            cursor: "not-allowed",
          }}
        >
          {cost.label}
        </CalciteButton>
      )}

      {/* Setting badge */}
      {locType && setting && (
        <CalciteButton
          class="lib-secondary-button setting-btn"
          appearance="solid"
          scale="s"
          style={{
            "--calcite-button-background-color": setting.bg,
            "--calcite-button-text-color": setting.text,
            "--calcite-button-corner-radius": "4px",
            padding: "2px 6px 6px 0px",
            pointerEvents: "none",
            cursor: "not-allowed",
          }}
        >
          {locType}-based care
        </CalciteButton>
      )}
    </>
  );
}